import "./Causes.css";
import {
  Search,
  Filter,
  Eye,
  Edit2,
  Trash2,
  MapPin,
  Users,
  Clock,
  AlertCircle,
  TrendingUp,
  Heart,
  Shield,
} from "lucide-react";
import { useEffect, useState } from "react";
import api from "../../services/api";
import { causelist } from "../../services/mainService";
import { useNavigate } from "react-router-dom";
import { Pagination } from "../../components/Pagination";

const causes = [
  {
    id: 1,
    title: "Self Sufficiency for Ulemas",
    category: "Zakat",
    createdBy: "ampindia",
    location: "Mumbai, Maharashtra",
    image:
      "https://plus.unsplash.com/premium_photo-1663054786557-031fe4ae56a3?q=80&w=2046&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    raised: 820283,
    goal: 1000000,
    daysLeft: 53,
    status: "approved",
    highPriority: true,
    description:
      "Supporting religious scholars to become self-sufficient through sustainable livelihood programs.",
    donors: 245,
  },
  {
    id: 2,
    title: "Medical Aid for Children",
    category: "Sadaqah",
    createdBy: "Fatima Noor",
    location: "Delhi",
    image: "https://images.unsplash.com/photo-1584515933487-779824d29309",
    raised: 45000,
    goal: 150000,
    daysLeft: 21,
    status: "pending",
    highPriority: false,
    description:
      "Providing medical assistance to underprivileged children with critical illnesses.",
    donors: 34,
  },
  {
    id: 3,
    title: "Orphan Education Fund",
    category: "Zakat",
    createdBy: "Islamic Relief",
    location: "Kolkata, West Bengal",
    image:
      "https://images.unsplash.com/photo-1643429096345-9de0d2ab7e7c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    raised: 1250000,
    goal: 1500000,
    daysLeft: 7,
    status: "filled",
    highPriority: false,
    description:
      "Educational support for orphaned children including school fees, books, and supplies.",
    donors: 156,
  },
  {
    id: 4,
    title: "Clean Water Project",
    category: "Sadaqah",
    createdBy: "Human Concern",
    location: "Rajasthan",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64",
    raised: 750000,
    goal: 1000000,
    daysLeft: 45,
    status: "approved",
    highPriority: true,
    description:
      "Installing water purification systems in drought-affected villages.",
    donors: 89,
  },
  {
    id: 5,
    title: "Emergency Flood Relief",
    category: "Emergency",
    createdBy: "Red Crescent",
    location: "Kerala",
    image:
      "https://images.unsplash.com/photo-1760500959977-c3d310ee876c?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    raised: 2000000,
    goal: 3000000,
    daysLeft: 15,
    status: "completed",
    highPriority: false,
    description:
      "Providing immediate relief to flood-affected families with food and shelter.",
    donors: 312,
  },
  {
    id: 6,
    title: "Ramadan Food Distribution",
    category: "Zakat",
    createdBy: "Local Mosque Committee",
    location: "Hyderabad",
    image: "https://images.unsplash.com/photo-1511910849309-0dffb8785146",
    raised: 180000,
    goal: 250000,
    daysLeft: 30,
    status: "fraud",
    highPriority: false,
    description: "Monthly food packages for needy families during Ramadan.",
    donors: 67,
  },
];

const AllCauses = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [causes, setcauses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setpagination] = useState({
    current_page: 1,
    per_page: 10,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const navigate = useNavigate();
  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };

  useEffect(() => {
    fetchcause();
  }, []);

  const fetchcause = async () => {
    try {
      const res = await causelist({ page: pagination.current_page });
      console.log(res);

      setcauses(res.data);
      setpagination(res.pagination_info);
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };
  const getStatusColor = (status) => {
    switch (status) {
      case "Approved":
        return "pending";
      case "fraud":
        return "fraud";
      default:
        return "";
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const calculatePercentage = (raised, goal) => {
    return Math.min(Math.round((raised / goal) * 100), 100);
  };

  // const filteredCauses = causes?.filter((cause) => {
  //   const matchesSearch =
  //     cause.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     cause.description.toLowerCase().includes(searchTerm.toLowerCase());
  //   const matchesStatus =
  //     statusFilter === "all" || cause.status === statusFilter;
  //   const matchesCategory =
  //     categoryFilter === "all" || cause.category === categoryFilter;

  //   return matchesSearch && matchesStatus && matchesCategory;
  // });
  // console.log(filteredCauses ? true : false);

  const stats = {
    total: causes?.length || 0,
    approved: causes?.filter((c) => c.status === "approved").length || 0,
    pending: causes?.filter((c) => c.status === "pending").length || 0,
    totalRaised: causes?.reduce((sum, cause) => sum + cause.raised, 0) || 0,
  };

  return (
    <div className="causes-page">
      {/* Page Header */}
      <div className="page-header">
        <h2> Causes</h2>
        <p>Manage and monitor all fundraising causes on the platform</p>
      </div>

      {/* Stats Summary */}
      {/* <div className="stats-grid">
        <div className="stat-box">
          <div className="stat-value">{stats.total}</div>
          <div className="stat-label">Total Causes</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">{stats.approved}</div>
          <div className="stat-label">Active Causes</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">{stats.pending}</div>
          <div className="stat-label">Pending Review</div>
        </div>
        <div className="stat-box">
          <div className="stat-value">{formatAmount(stats.totalRaised)}</div>
          <div className="stat-label">Total Raised</div>
        </div>
      </div> */}

      {/* Controls Bar */}
      {/* <div className="controls-bar">
        <div className="search-box">
          <Search />
          <input
            type="text"
            placeholder="Search causes..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="filter-section">
          <div className="filter-group">
            <span className="filter-label">
              <Filter size={16} /> Status:
            </span>
            <div className="filter-buttons">
              <button
                className={`filter-btn ${statusFilter === "all" ? "active" : ""}`}
                onClick={() => setStatusFilter("all")}
              >
                All
              </button>
              <button
                className={`filter-btn ${statusFilter === "approved" ? "active" : ""}`}
                onClick={() => setStatusFilter("approved")}
              >
                Published
              </button>
              <button
                className={`filter-btn ${statusFilter === "pending" ? "active" : ""}`}
                onClick={() => setStatusFilter("pending")}
              >
                Pending
              </button>
              <button
                className={`filter-btn ${statusFilter === "fraud" ? "active" : ""}`}
                onClick={() => setStatusFilter("fraud")}
              >
                Fraud
              </button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Results Count */}
      <div className="results-count">
        Showing {causes?.length} of {causes?.length} causes
      </div>

      {/* Causes Grid */}
      {causes.length === 0 ? (
        <div className="empty-state">
          <Shield size={64} />
          <h3>No causes found</h3>
          {/* <p>Try adjusting your search or filter criteria</p>
          <button
            className="reset-btn"
            onClick={() => {
              setSearchTerm("");
              setStatusFilter("all");
              setCategoryFilter("all");
            }}
          >
            Reset Filters
          </button> */}
        </div>
      ) : (
        <>
          <div className="allcause_card_grid">
            {causes?.map((cause, index) => (
              <div
                key={cause.id}
                className="allcause_card"
                style={{ "--card-index": index }}
              >
                {/* Card Header with Image */}
                <div className="card-header">
                  <img
                    src={cause.image}
                    alt={cause.title}
                    className="card-image"
                    loading="lazy"
                  />
                  <div className="card-overlay"></div>

                  {/* Status Badge */}
                  <span
                    className={`status-badge ${getStatusColor(cause.status)}`}
                  >
                    {cause.status.charAt(0).toUpperCase() +
                      cause.status.slice(1)}
                  </span>

                  {/* Priority Badge */}
                  {cause.highPriority && (
                    <div className="priority-badge">
                      <AlertCircle size={12} />
                      High Priority
                    </div>
                  )}
                </div>

                {/* Card Content */}
                <div className="card-content">
                  {/* Title and Category */}
                  <h3 className="card-title">{cause.title}</h3>
                  <div className="card-description">{cause.description}</div>

                  {/* Meta Information */}
                  <div className="card-meta">
                    <div className="meta-item">
                      <Users size={14} />
                      <span>{cause.category}</span>
                    </div>
                    <div className="meta-item">
                      <MapPin size={14} />
                      <span>
                        {cause.district} {cause.state}
                      </span>
                    </div>
                    <div className="meta-item">
                      <Heart size={14} />
                      <span>cause for{cause.cause_for} </span>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="progress-section">
                    <div className="progress-header">
                      <div className="raised-amount">
                        {formatAmount(cause.amount_collected)}
                        <span>raised</span>
                      </div>
                      <div className="goal-amount">
                        Goal: {formatAmount(cause.amount_required)}
                      </div>
                    </div>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{
                          width: `${calculatePercentage(cause.amount_collected, cause.amount_required)}%`,
                        }}
                      ></div>
                    </div>
                    <div className="progress-info">
                      <span className="percentage">
                        {calculatePercentage(
                          cause.amount_collected,
                          cause.amount_required,
                        )}
                        % funded
                      </span>
                      {/* <span className="time-left">
                        <Clock size={14} />
                        {cause.daysLeft} days left
                      </span> */}
                    </div>
                  </div>

                  {/* Card Footer */}
                  {/* <div className="card-footer">
                    <div className="creator-info">
                      <img
                        src={`https://ui-avatars.com/api/?name=${cause.createdBy}&background=2E8B57&color=fff`}
                        alt={cause.createdBy}
                        className="creator-avatar"
                      />
                      <div className="creator-details">
                        <h4>{cause.createdBy}</h4>
                        <p>Organizer</p>
                      </div>
                    </div>

                    <div className="time-left">
                      <Clock size={14} />
                      {cause.daysLeft}d left
                    </div>
                  </div> */}
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  <button
                    className="action-btn view"
                    title="View Details"
                    onClick={() => navigate("/cause-details", { state: cause })}
                  >
                    <Eye size={18} />
                  </button>
                  {/* <button className="action-btn edit" title="Edit">
                    <Edit2 size={18} />
                  </button>
                  <button className="action-btn delete" title="Delete">
                    <Trash2 size={18} />
                  </button> */}
                </div>
              </div>
            ))}
            {/* Pagination */}
          </div>
          <Pagination pagination={pagination} fetchdata={fetchcause} />
        </>
      )}
    </div>
  );
};

export default AllCauses;
